import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from '@tanstack/react-router';

export interface LegalPageProps {
  children: ReactNode;
  title: string;
}

export const LegalPageLayout: FC<LegalPageProps> = ({ children, title }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-dvh bg-background px-4 py-10 pt-[max(2.5rem,env(safe-area-inset-top))] pb-[max(2.5rem,env(safe-area-inset-bottom))]">
      <div className="mx-auto max-w-3xl space-y-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h1 className="min-w-0 break-words text-2xl font-semibold tracking-tight sm:text-3xl">
            {title}
          </h1>
          <Link
            className="shrink-0 cursor-pointer text-sm text-muted-foreground hover:text-foreground"
            to="/login">
            {t('buttons.login')}
          </Link>
        </div>
        <div className="space-y-4 rounded-2xl border border-border bg-card p-6 text-sm leading-relaxed text-foreground/90">
          {children}
        </div>
        <p className="text-center text-xs text-muted-foreground">
          <Link className="cursor-pointer hover:text-foreground" to="/terms">
            {t('legal.terms')}
          </Link>
          {' · '}
          <Link className="cursor-pointer hover:text-foreground" to="/privacy">
            {t('legal.privacy')}
          </Link>
          {' · '}
          <Link className="cursor-pointer hover:text-foreground" to="/contacts">
            {t('legal.contacts')}
          </Link>
        </p>
      </div>
    </div>
  );
};

LegalPageLayout.displayName = 'LegalPageLayout';
